/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import ScheduleTrigger from './ScheduleTrigger';
import TriggerSummary from './TriggerSummary';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
// @ts-ignore
import Papa from 'papaparse/papaparse.min.js';
import type {appConfigs } from '../types/types';
import MainLayout from '../Layouts/Mainlayout';
import { Grid } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import type { TriggerFormData} from '../types/types';
import { addlisttrigger, getlisttriggerById } from 'src/services/triggerService';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {IdeaSolidRounded} from '@hugeicons-pro/core-solid-rounded';
import {checkEventPermission} from "../../common/utility/utility";
const steps = ['Import List', 'Schedule Trigger', 'Confirmation'];
export interface ApiResponse {
status: number;
data: {
    data: [];
    result:number;
    messages: any;
};
}

function NewRequestImport(): JSX.Element {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [MaxRequestBodySizeData, setMaxRequestBodySizeData] =
    useState<string>('');
  const navigate = useNavigate();
  const [savedTriggerData, setSavedTriggerData] = useState<TriggerFormData>();
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [savedTriggerID, setSavedTriggerID] =useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [totalNpiRecords,setTotalNpiRecords] = useState<number>(0);
  console.log(isFormValid);

  useEffect(() => {
    const storedAppConfig = localStorage.getItem('appConfigs');
    if (storedAppConfig !== null && storedAppConfig !== '') {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        const maxRequestBodySize = parsedAppConfig.find(
          (item) => item.configName === 'MaxRequestBodySize',
        )?.configValue;
        if (maxRequestBodySize != null) {
          setMaxRequestBodySizeData(maxRequestBodySize);
        }
      } catch (error) {
        console.error('Error parsing appConfig data:', error);
      }
    }
  }, []);
  useEffect(() => {
    setLoading(true)
    console.log(savedTriggerID);
    getlisttriggerById(savedTriggerID)
      .then(
        (res: ApiResponse) => {
          console.log(res);
          console.log(res.data);
          console.log(res.data.result);
          if (res.status === 200) {         
            //@ts-ignore     
            setSavedTriggerData(res.data.data);
            setLoading(false)
          }
        }
      ) 
      .catch (
        error => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })

}, [savedTriggerID]);
  // Convert maxRequestBodySizeData to MB and round it
  const mbValue = Math.round(parseInt(MaxRequestBodySizeData) / 1024 / 1024);
  const handleFormValidation = (isValid: boolean): void => {
    setIsFormValid(isValid);
};
  const onDrop = useCallback(
    (acceptedFiles: any, rejectedFiles: any) => {
      if (rejectedFiles.length > 0) {
        NotificationManager.error('Please select valid file');
      } else {
        if (MaxRequestBodySizeData !== "") {
          validateFile(acceptedFiles);
        } else {
          NotificationManager.error('Max request body size not available.');
        }
      }
    },
    [MaxRequestBodySizeData],
  );
  const validateFile = (selectedFiles: File[]): void => {
    let csv: any;
    let data: any;
    if (selectedFiles[0]?.size > parseInt(MaxRequestBodySizeData)) {
        
        NotificationManager.error(`File size must be less than ${mbValue} MB`);
        return;
    }

    // Check file extension
    const extension = selectedFiles[0]?.name.split('.').pop()?.toLowerCase();
    if (extension !== 'csv') {
        NotificationManager.error("The file must be in CSV format.");
        return;
    }

    const reader = new FileReader();

    if (selectedFiles.length > 0) {
        reader.onload = function () {
            // Parse CSV data
            data = reader.result;

            // Parse data with PapaParse
            csv = Papa.parse(data, {
                delimiter: ",",
                download: false,
                dynamicTyping: false,
                encoding: "",
                header: false,
                preview: 0,
                skipEmptyLines: false,
                step: undefined,
                worker: false,
            });

            const records = csv.data as string[][];

            // Validate file content
            if (records.length === 0) {
                NotificationManager.error("The file is empty. Please select a valid file with at least one record.");
                return;
            }

            const headerRow = records[0];
            if (!headerRow || headerRow.length === 0) {
                NotificationManager.error("The file must contain at least one column.");
                return;
            }

            // Check for any empty column headers
            if (headerRow.some((header: string) => header.trim() === "")) {
                NotificationManager.error("The file contains empty headers. Please provide valid column headers.");
                return;
            }

            const trimmedHeaders = headerRow.map((header: string) => header.trim().toLowerCase());
            const uniqueHeaders = new Set(trimmedHeaders);
            if (uniqueHeaders.size !== headerRow.length) {
                NotificationManager.error("The file contains duplicate column headings. Please ensure all column headers are unique.");
                return;
            }

            // Validate column headers for SQL naming conventions (allow letters, numbers, spaces, and underscores)
            const invalidHeaderPattern = /[^a-zA-Z0-9 _]/; // Disallow characters except letters, numbers, spaces, and underscores
            const invalidHeaders = headerRow.filter((header: string) => invalidHeaderPattern.test(header.trim()));
            if (invalidHeaders.length > 0) {
                NotificationManager.error(
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    // `Invalid column headings found: ${invalidHeaders.join(", ")}. ` +
                    // "Column names must only contain letters, numbers, spaces, and underscores."
                    "Invalid column headings found."
                );
                return;
            }

            if (records.length === 1) {
                NotificationManager.error("The file must contain at least one data record.");
                return;
            }
            
            // Find NPI column index
            const npiColumnIndex = trimmedHeaders.findIndex(header => header.toLowerCase() === 'npi'); 
            if (!trimmedHeaders.includes("npi")) {
              NotificationManager.error('The file must contain an "NPI" column.');
              return;
          }

            // Count distinct NPI values if NPI column exists
            let distinctNpiCount = 0;
            if (npiColumnIndex !== -1) {
                const npiValues = new Set(
                    records
                        .slice(1) // Skip header row
                        .map(row => row[npiColumnIndex])
                        .filter(npi => npi && npi.trim() !== '') // Filter out empty values
                );
                distinctNpiCount = npiValues.size;
            }
            setTotalNpiRecords(distinctNpiCount);
            sessionStorage.setItem("totalNpiRecords", JSON.stringify(distinctNpiCount));
console.log(distinctNpiCount);
            setSelectedFiles(selectedFiles);
            NotificationManager.success("File is valid and ready for upload.");
        }
    }

    // Read CSV file as text
    reader.readAsText(selectedFiles[0]);
};    

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'text/csv': ['.csv'] },
    maxFiles: 1,
  });

  const [activeStep, setActiveStep] = React.useState(0);
  
  const handleNext = async (): Promise<void> => {
    if (activeStep === 0 && selectedFiles.length === 0) {
        NotificationManager.error('Please upload a file before proceeding');
        return;
    }
    if (activeStep === 1) {
      setSubmitAttempted(true);
      // Reset the submit attempt flag after a short delay
      setTimeout(() => {
          setSubmitAttempted(false);
      }, 100);
      return;
  }
    setActiveStep((prevStep) => prevStep + 1);
};
  const handleBack = (): void => {
    setActiveStep((prevStep) => prevStep - 1); // Go to the previous step
  };

    const handleCancel = (): void => {
    navigate('/trigger');
  };

const handleFormSubmit = (data: TriggerFormData): void => {
  console.log(data);
  try {
      const userData = JSON.parse(localStorage.getItem("user") ?? "");
      
      const triggerData = {
          clientId: userData?.clientId ?? 0,
          campaignId: data.campaignId,
          listTriggerName: data.triggername,
          startDate: data.startOn,
          endDate: data.triggerenddate,
          totalNPI: totalNpiRecords,
          createdBy: userData.id
      };

      // Create FormData object
      const formData = new FormData();
      
      // Append the file
      if (selectedFiles[0]) {
          formData.append('file', selectedFiles[0]);
      } else {
          NotificationManager.error('No file selected');
          return;
      }
      
      // Append the JSON data
      formData.append('requestData', JSON.stringify(triggerData));

      addlisttrigger(formData)
          .then((res: ApiResponse) => {
              if (res.status === 200) {
                  if (res.data.result === 1) {
                    console.log(res.data);
                    console.log(res.data.data);
                    //@ts-ignore
                    setSavedTriggerID(res.data.data.listTriggerID);
                      // NotificationManager.success(TRIGGER_CREATE_SUCCESS_MESSAGE, '', 5000);
                      setActiveStep((prevStep) => prevStep + 1);
                  } else {
                    console.log(res.data);
                    const errorMessage = res.data.messages[0].message.includes('A List Trigger Name with the same name already exists for this client.') ? "List trigger name already exists." : "Failed to create trigger";
                    NotificationManager.error(errorMessage);
                  }
              }
          })
          .catch((error: any) => {
              console.error("Error", error);
              NotificationManager.error('Failed to submit trigger');
          });
  } catch (error) {
      console.error("Error processing form submission:", error);
      NotificationManager.error('Error processing form data');
  }
};


  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        {/* <h2 className="text-2xl font-semibold text-title mb-[20px]">New Request</h2> */}
        <div className="flex justify-between items-center">
       
          <div className="w-full">
            <div>
              <h1 className="text-2xl text-title font-semibold">
                New List Trigger
              </h1>

              <Box sx={{ flexGrow: 1 }}>
              {loading ?
        <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                <div className="campaign-form-container">
                  <Grid>
                    <Box sx={{ width: '60%', marginTop: '10px', mx: 'auto' }}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>

                      {activeStep === 0 && (
                        <div style={{ marginTop: '40px' }}>
                          {selectedFiles.length > 0 ? (
                            selectedFiles.map((file) => (
                              <div key={file.name} className="dropzone">
                                <span className="font-semibold">
                                  {file.name}
                                </span>
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => setSelectedFiles([])}
                                  style={{ color: 'red', paddingTop: '10px' }}
                                >
                                  Remove
                                </a>
                              </div>
                            ))
                          ) : (
                            <div {...getRootProps({ className: 'dropzone' })}>
                              <input {...getInputProps()} />
                              {isDragActive ? (
                                <p>Drop the files here ...</p>
                              ) : (
                                <>
                                  <p>
                                    <strong className='font-semibold'>Drag and drop or</strong>
                                    <span
                                      style={{
                                        color: '#d6242c',
                                        cursor: 'pointer',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {' '}
                                      Click here{' '}
                                    </span>
                                    <strong className='font-semibold'>to choose file.</strong>
                                  </p>

                                  <span
                                    style={{
                                      display: 'block',
                                      marginTop: '20px',
                                      fontSize: '14px',
                                      color: '#3A3A3A',
                                    }}
                                  >
                                    {mbValue && `Max size ${mbValue} MB . `}{' '}
                                    File format: CSV
                                  </span>
                                </>
                              )}
                            </div>
                          )}

                          <Box
                            sx={{
                              textAlign: 'left',
                              mt: 3,
                              p: 1,
                              bgcolor: '#f5f5f5',
                              borderRadius: '8px',
                              boxShadow: 0,
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: '600',
                                color: '#3A3A3A',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                               <HugeiconsIcon
                                icon={IdeaSolidRounded}
                                size={20} 
                                color="#3A3A3A"
                                strokeWidth={0.2}
                                style={{ marginRight: 10}}
                                  /> {' '}
                              NPI Import Instructions
                            </Typography>

                            <ul
                              style={{
                                paddingLeft: '20px',
                                marginTop: '12px',
                                color: '#3A3A3A',
                                lineHeight: '1.8',
                              }}
                            >
                              <li
                                style={{
                                  listStyleType: 'disc',
                                  marginBottom: '8px',
                                }}
                              >
                                <a
                                    href="/assets/listtrigger-files/sample.csv"
                                    download="sample.csv"
                                    style={{
                                      color: '#d6242c',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    Download
                               
                                </a>{' '}
                                a sample CSV file
                              </li>
                              <li
                                style={{
                                  listStyleType: 'disc',
                                  marginBottom: '8px',
                                }}
                              >
                                Ensure that your file is in CSV format.
                              </li>
                              <li
                                style={{
                                  listStyleType: 'disc',
                                  marginBottom: '8px',
                                }}
                              >
                                Verify that the file size does not exceed{' '}
                                {mbValue} MB.
                              </li>
                            </ul>
                          </Box>
                        </div>
                      )}
                    </Box>
                    {activeStep === 1 && (
                      <div style={{ marginTop: '40px' }}>
                        {/* @ts-ignore */}
                        <ScheduleTrigger 
                    onFormValidation={handleFormValidation}
                    onDataSubmit={handleFormSubmit}
                    submitAttempted={submitAttempted}
                />
                      </div>
                    )}
                    {activeStep === 2 && savedTriggerData &&  (
                     //@ts-ignore

                        <TriggerSummary savedTriggerData = {savedTriggerData} />
                      
                    )}
                  </Grid>
{activeStep !== 2 && 
                  <div className="bg-white p-4 mt-4">
                    {/* Gray Horizontal Line */}
                    <hr
                      className="border-t"
                      style={{ borderColor: '#D3D3D3' }}
                    />

                    {/* Buttons */}

                    <div className="flex gap-2 justify-end mt-4">
                      {activeStep !== 0 &&  (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: '12px',
                          }}
                        >
                          <button
                            type="button"
                            onClick={handleBack}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#666',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              padding: '8px 16px',
                              fontSize: '14px',
                            }}
                          >
                            <span style={{ color: '#666' }}>←</span> Back
                          </button>
                        </div>
                      )}
                      
                          <OutlineButton
                            color="gray"
                            onClick={() => handleCancel()}
                            width="130px"
                          >
                            Cancel
                          </OutlineButton>
                          <GradientButton
                            color="red"
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                            onClick={() => handleNext()}
                            disabled={
                              activeStep == 1 && !checkEventPermission('LISTTRIGGER_ADD')
                            }
                            width="130px"
                          >
                            {'Next >'}
                          </GradientButton>
                                             
                    </div>
                  </div>

                    }
                </div>
}
              </Box>
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
}

export default NewRequestImport;
